import React from "react";

import BillingAddressSection from "../CompanyContactForm/Components/BillingAddressSection";
import ContactInfoSection from "../CompanyContactForm/Components/ContactInfoSection";

/**
 * Billing + contact step for "Manage as an independent location".
 * Reuses the company contact billing UI (matches Setup your billing information).
 */
export default function LocationBillingDetails({
  emailValidator,
  phoneValidator,
  addressData,
  initialValues,
}) {
  return (
    <div className="LocationBillingDetails">
      <BillingAddressSection
        initialValues={initialValues}
        emailValidator={emailValidator}
        phoneValidator={phoneValidator}
        addressData={addressData}
        contactSection={(
          <ContactInfoSection
            emailValidator={emailValidator}
            phoneValidator={phoneValidator}
          />
        )}
      />
    </div>
  );
}
